import { useCallback } from 'react';
import {
  Badge,
  Box,
  ScrollPane,
  SegmentedControl,
} from '@nimbus-ds/components';
import classNames from 'classnames';
import { SavedSearchInterface } from 'domains/Orders/Orders/ordersSlice/savedSearches';
import { SAVED_SEARCHES_COUNT_LIMIT } from 'domains/Orders/Orders/pages/constants';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import { SavedSearchPopoverWrapper } from './SavedSearchPopoverWrapper';
import './SavedSearch.scss';

interface SavedSearchProperties {
  savedSearch: SavedSearchInterface;
  isSelected: boolean;
  count?: number;
  onSavedSearchClick: (savedSearch: SavedSearchInterface) => void;
}

export function SavedSearch({
  savedSearch,
  isSelected,
  count,
  onSavedSearchClick,
}: SavedSearchProperties) {
  const t = useTranslationOrders();

  const onClick = useCallback(() => {
    onSavedSearchClick(savedSearch);
  }, [onSavedSearchClick, savedSearch]);

  const classNameBadge = classNames('stratus--saved-search-badge', {
    'stratus--selected-saved-search-badge': isSelected,
  });

  const countToShow =
    count && count > SAVED_SEARCHES_COUNT_LIMIT && !isSelected
      ? `+${SAVED_SEARCHES_COUNT_LIMIT}`
      : count;

  return (
    <ScrollPane.Item key={savedSearch.id}>
      <SegmentedControl.Button id={savedSearch.id} onClick={onClick}>
        <SavedSearchPopoverWrapper
          isSelected={isSelected}
          savedSearch={savedSearch}
        >
          <Box
            flexDirection="row"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Box fontSize="3" fontWeight="regular" lineHeight="4">
              {savedSearch.isDefault
                ? t(`savedSearches.default.${savedSearch.key}`)
                : savedSearch.name}
            </Box>
            {countToShow !== undefined && (
              <Box paddingLeft="1">
                <div className={classNameBadge}>
                  <Badge
                    count={countToShow}
                    theme={isSelected ? 'light' : 'surface'}
                  />
                </div>
              </Box>
            )}
          </Box>
        </SavedSearchPopoverWrapper>
      </SegmentedControl.Button>
    </ScrollPane.Item>
  );
}
